import React, { useContext } from 'react'
import AppContext from '../context'
import { Checkbox } from '@missionlabs/smartagent-app-components';

interface Props {

}

const BasketStatus: React.FC<Props> = () => {
    const { cart } = useContext(AppContext);
    return (
        <section className="height-half">
            <header>
                <h2>Basket Status</h2>
            </header>

            {!!cart && (
                <div className="row column sm-pad">

                    <Checkbox
                        square
                        checked={cart?.progress.hasProducts}
                        label="Products in basket"
                    />
                    <Checkbox
                        square
                        checked={cart?.progress.hasDeliveryAddress}
                        label="Delivery address entered" 
                    />
                    <Checkbox
                        square
                        checked={cart?.progress.hasBillingAddress}
                        label="Billing address entered"
                    />
                    <Checkbox
                        square
                        checked={cart?.progress.hasDeliveryMethod}
                        label="Delivery method selected"
                    />

                </div>
            )}
        </section>
    )
}

export default BasketStatus;